(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ads-landing-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const PRICE_PATTERN = /\s+[A-Z]{3}\s*$/;

  function moneyLabel(root) {
    const sale = root.querySelector('.price__sale .price-item--sale');
    const regular = root.querySelector('.price__regular .price-item--regular');
    const node = sale && sale.offsetParent !== null ? sale : regular;
    if (!node) return '';
    return node.textContent.replace(PRICE_PATTERN, '').trim();
  }

  function paintAddToCart(root) {
    if (!root.classList.contains('ads-size-chosen')) return;
    const button = root.querySelector('.product-form__submit');
    const label = button && button.querySelector('span');
    if (!button || !label || button.hasAttribute('disabled')) return;
    const price = moneyLabel(root);
    if (!price) return;
    label.textContent = 'Add to cart — ' + price;
  }

  function dashColor(root) {
    root.querySelectorAll('.selected-color-wrapper strong').forEach((node) => {
      node.textContent = 'Color — ';
    });
  }

  function clearPendingSize(root) {
    if (root.classList.contains('ads-size-chosen')) return;
    root.querySelectorAll('.size-variant-wrapper input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
  }

  function init(root) {
    if (!root || root.dataset.adsReady === 'true') return;
    root.dataset.adsReady = 'true';

    const preset = new URLSearchParams(window.location.search).has('variant');
    if (preset) root.classList.add('ads-size-chosen');

    dashColor(root);
    clearPendingSize(root);
    paintAddToCart(root);

    root.addEventListener('click', (event) => {
      if (!event.target.closest('[data-ads-choose-size]')) return;
      event.preventDefault();
      const target = root.querySelector('.ads-variant-layout');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => root.classList.add('ads-size-prompt'));
      });
    });

    root.addEventListener('change', (event) => {
      if (event.target.closest('.color-variant-wrapper')) scheduleGallery(root);
      if (!event.target.closest('.size-variant-wrapper')) return;
      root.classList.add('ads-size-chosen');
      root.classList.remove('ads-size-prompt');
      paintAddToCart(root);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.setTimeout(() => {
          dashColor(root);
          clearPendingSize(root);
          paintAddToCart(root);
          scheduleGallery(root);
        }, 40);
      });
    }
  }

  const galleryMax = 5;

  function cleanColor(value) {
    return (value || '').toLowerCase().replace(/[™®©]/g, '').replace(/\s+/g, ' ').trim();
  }

  function activeColor(root) {
    const input = root.querySelector('.color-variant-wrapper input[type="radio"]:checked');
    return input ? input.value : '';
  }

  function cruiseImage(root, color) {
    const node = root.querySelector('[data-ads-cruise-images]');
    if (!node) return null;
    let images = [];
    try {
      images = JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
    const want = cleanColor(color);
    if (!want) return null;
    const named = images.find((item) => cleanColor(item.color) === want);
    if (named) return named;
    const words = want.split(' ').filter((word) => word.length > 2);
    return (
      images.find((item) => {
        const name = cleanColor(item.color);
        return words.some((word) => name.includes(word));
      }) || null
    );
  }

  function ensureCruiseNodes(root) {
    const list = root.querySelector('.product__media-list');
    const thumbs = root.querySelector('.thumbnail-list');
    if (!list || !thumbs) return;
    const mediaId = root.dataset.section + '-cruise';
    let slide = [...list.children].find((node) => node.dataset.adsCruise === 'true');
    if (!slide) {
      slide = document.createElement('li');
      slide.className = 'product__media-item grid__item slider__slide';
      slide.dataset.mediaId = mediaId;
      slide.dataset.adsCruise = 'true';
      slide.innerHTML = '<div class="ads-cruise-frame"><img class="ads-cruise-photo" alt=""></div>';
      list.appendChild(slide);
    }
    let thumb = [...thumbs.children].find((node) => node.dataset.adsCruise === 'true');
    if (!thumb) {
      thumb = document.createElement('li');
      thumb.className = 'thumbnail-list__item slider__slide';
      thumb.dataset.target = mediaId;
      thumb.dataset.adsCruise = 'true';
      thumb.innerHTML =
        '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Cruise photo"><img alt=""></button>';
      thumbs.appendChild(thumb);
    }
    const button = thumb.querySelector('button');
    if (button && button.dataset.adsBound !== 'true') {
      button.dataset.adsBound = 'true';
      button.addEventListener('click', () => {
        ensureCruiseNodes(root);
        const gallery = root.querySelector('media-gallery');
        if (gallery && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(mediaId, false);
      });
    }
  }

  function capGallery(root) {
    ensureCruiseNodes(root);
    root.querySelectorAll('.ads-gallery-over').forEach((node) => node.classList.remove('ads-gallery-over'));
    const cruise = cruiseImage(root, activeColor(root));
    const slide = root.querySelector('.product__media-item[data-ads-cruise="true"]');
    const thumb = root.querySelector('.thumbnail-list__item[data-ads-cruise="true"]');
    const room = cruise ? galleryMax - 1 : galleryMax;
    ['.product__media-item', '.thumbnail-list__item'].forEach((selector) => {
      const items = [...root.querySelectorAll(selector)].filter(
        (node) => node.dataset.adsCruise !== 'true' && node.style.display !== 'none'
      );
      items.forEach((node, index) => {
        if (index >= room) node.classList.add('ads-gallery-over');
      });
    });
    if (slide) slide.classList.remove('ads-cruise-on');
    if (thumb) thumb.classList.remove('ads-cruise-on');
    if (!slide || !thumb || !cruise) {
      if (slide) slide.classList.add('ads-gallery-over');
      if (thumb) thumb.classList.add('ads-gallery-over');
      revealActive(root);
      return;
    }
    slide.classList.remove('ads-gallery-over');
    thumb.classList.remove('ads-gallery-over');
    thumb.classList.add('ads-cruise-on');
    const label = activeColor(root) || cruise.color;
    [slide, thumb].forEach((node) => {
      const image = node.querySelector('img');
      if (!image) return;
      if (image.getAttribute('src') !== cruise.src) image.setAttribute('src', cruise.src);
      image.alt = label;
    });
    const firstThumb = [...root.querySelectorAll('.thumbnail-list__item')].find(
      (node) => node !== thumb && node.style.display !== 'none' && !node.classList.contains('ads-gallery-over')
    );
    if (firstThumb && firstThumb.nextSibling !== thumb) thumb.parentElement.insertBefore(thumb, firstThumb.nextSibling);
    revealActive(root);
  }

  function revealActive(root) {
    const thumb =
      root.querySelector('.thumbnail-list__item:not(.ads-gallery-over) button[aria-current]')?.closest('.thumbnail-list__item') ||
      [...root.querySelectorAll('.thumbnail-list__item')].find(
        (node) => node.style.display !== 'none' && !node.classList.contains('ads-gallery-over')
      );
    if (!thumb) return;
    const slide = [...root.querySelectorAll('.product__media-item')].find(
      (node) => node.dataset.mediaId === thumb.dataset.target
    );
    if (!slide) return;
    root.querySelectorAll('.product__media-item').forEach((node) => {
      const on = node === slide;
      node.classList.toggle('is-active', on);
      if (on) {
        node.classList.remove('ads-gallery-over');
        node.style.display = 'block';
      }
    });
    root.querySelectorAll('.thumbnail-list__item button').forEach((button) => button.removeAttribute('aria-current'));
    const button = thumb.querySelector('button');
    if (button) button.setAttribute('aria-current', 'true');
    const list = root.querySelector('.product__media-list');
    if (list) list.scrollLeft = 0;
  }

  function watchGallery(root) {
    const list = root.querySelector('.product__media-list');
    if (!list || list.dataset.adsWatch === 'true') return;
    list.dataset.adsWatch = 'true';
    let timer;
    const observer = new MutationObserver(() => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => capGallery(root), 40);
    });
    observer.observe(list, { attributes: true, attributeFilter: ['style'], childList: true });
    const thumbs = root.querySelector('.thumbnail-list');
    if (thumbs) observer.observe(thumbs, { attributes: true, attributeFilter: ['style'], childList: true });
    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('.thumbnail-list__item');
      if (!thumb || !root.contains(thumb)) return;
      [0, 60].forEach((delay) => window.setTimeout(() => revealActive(root), delay));
    });
  }

  function scheduleGallery(root) {
    [0, 80, 220, 450].forEach((delay) => window.setTimeout(() => capGallery(root), delay));
  }

  function pinGalleryScroll(root) {
    const gallery = root.querySelector('media-gallery');
    if (!gallery || gallery.dataset.adsPinScroll === 'true' || typeof gallery.setActiveMedia !== 'function') return;
    gallery.dataset.adsPinScroll = 'true';
    const original = gallery.setActiveMedia;
    if (!pinGalleryScroll.native) pinGalleryScroll.native = window.scrollTo.bind(window);
    gallery.setActiveMedia = function (mediaId, prepend) {
      const y = window.scrollY;
      pinGalleryScroll.holds = (pinGalleryScroll.holds || 0) + 1;
      window.scrollTo = function (options, top) {
        const next = options && typeof options === 'object' ? options.top : top;
        if (typeof next === 'number' && Math.abs(next - y) > 8) return;
        return pinGalleryScroll.native.call(window, options, top);
      };
      original.call(gallery, mediaId, prepend);
      window.setTimeout(() => {
        pinGalleryScroll.holds -= 1;
        if (pinGalleryScroll.holds <= 0) {
          pinGalleryScroll.holds = 0;
          window.scrollTo = pinGalleryScroll.native;
        }
      }, 80);
    };
  }

  function boot() {
    document.querySelectorAll('product-info.ads-landing').forEach((root) => {
      init(root);
      watchGallery(root);
      pinGalleryScroll(root);
      scheduleGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ads-gender]');
    if (!button) return;
    const audience = button.dataset.adsGender;
    document.querySelectorAll('[data-ads-audience]').forEach((node) => {
      node.hidden = node.dataset.adsAudience !== audience;
    });
    document.querySelectorAll('[data-ads-gender]').forEach((node) => {
      const active = node.dataset.adsGender === audience;
      node.classList.toggle('is-active', active);
      if (active) node.setAttribute('aria-current', 'true');
      else node.removeAttribute('aria-current');
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('product-info.ads-landing');
    if (root) {
      delete root.dataset.adsReady;
      init(root);
      pinGalleryScroll(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
